module.exports = "/img/city-london.b26bae94.jpg";